export const kits = {
  title: "Combos",
  createCta: "Create combo",
  counter_one: "combo",
  counter_other: "combos",
  empty: {
    title: "Create your first combo",
    description:
      "Group products with a discount and sell more with attractive offers.",
    cta: "Create combo",
  },
  noProducts: {
    title: "You need at least 2 products",
    description:
      "To create a combo you must have at least two products in your catalog.",
    cta: "Create product",
  },
  enabledByProductsWarning:
    "This combo cannot be enabled because one or more of its products are unavailable.",
  selector: {
    title: "Select products",
    description: "Choose between 2 and 5 products to build your combo.",
    searchPlaceholder: "Search products",
    allCategories: "All categories",
    continue: "Continue",
    selectedCount: "{{count}}/{{max}} selected",
    status: {
      variation: "Has variants",
      inactive: "Inactive",
      soldOut: "Sold out",
    },
    infoBanner:
      "Products with variants, inactive products, or out-of-stock items cannot be included in a combo.",
    emptySearch: "No products matched your search.",
  },
  form: {
    createTitle: "Create combo",
    editTitle: "Edit combo",
    nameLabel: "Combo name",
    namePlaceholder: "E.g. Family combo",
    defaultName: "New combo",
    productsTitle: "Products",
    discountTitle: "Discount",
    discountPercentage: "%",
    discountValue: "$",
    imagesTitle: "Images",
    imagesHint: "You can add up to {{max}} images",
    addImage: "Add image",
    save: "Save",
    delete: "Delete combo",
    deleteConfirmTitle: "Delete this combo?",
    deleteConfirmDescription:
      "This action cannot be undone. The combo will no longer be available in your store.",
    deleteConfirmCta: "Yes, delete",
    deleteCancelCta: "Cancel",
    priceWithoutDiscount: "Price without discount",
    priceFinal: "Final price",
    maxQuantityAlert: "You reached the maximum units for this product.",
    nameRequired: "Name is required",
    saveSuccessCreate: "Combo created successfully",
    saveSuccessUpdate: "Combo updated successfully",
    saveError: "We could not save the combo. Please try again.",
    deleteError: "We could not delete the combo. Please try again.",
    toggleError: "We could not update the combo status.",
  },
};
